
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/picture-dictionaries",
      function () {
        return require("private-next-pages/picture-dictionaries/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/picture-dictionaries"])
      });
    }
  